/* Ankauf-Seiten im Shopify-Theme. Preise und Auftraege kommen nicht von
   Shopify, sondern vom eigenen Ankauf-Server (data-server am Abschnitt). */
(() => {
  'use strict';

  // Steht der Abschnitt zweimal auf einer Seite, laeuft diese Datei zweimal.
  // Dann nur die neuen Abschnitte einrichten.
  if (window.ankaufEinrichten) {
    window.ankaufEinrichten();
    return;
  }

  const SCHRITTE = ['marke', 'modell', 'speicher', 'daten'];

  const euro = (cent) => (cent / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

  const datumLang = (iso) =>
    new Date(iso + 'T00:00:00').toLocaleDateString('de-DE', { day: 'numeric', month: 'long', year: 'numeric' });

  const eindeutig = (werte) => [...new Set(werte)];

  function speicherInGb(text) {
    const zahl = parseFloat(text);
    return /tb/i.test(text) ? zahl * 1024 : zahl;
  }

  function hoechstpreis(liste) {
    const max = Math.max(...liste.map((g) => g.bestpreis_cent));
    return liste.length === 1 ? euro(max) : 'bis ' + euro(max);
  }

  function serverAdresse(wurzel) {
    const adresse = (wurzel.dataset.server || '').trim().replace(/\/+$/, '');
    if (/^https:\/\/[^\s/?#]+(\/[^\s?#]*)?$/.test(adresse)) return adresse;
    // Nur zum Testen auf dem eigenen Rechner.
    if (/^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/.test(adresse)) return adresse;
    return null;
  }

  // Eine Preisabfrage pro Seite, auch wenn mehrere Abschnitte sie brauchen.
  const preisAnfragen = new Map();

  function ladeGeraete(server) {
    if (!server) return Promise.reject(new Error('Keine Server-Adresse'));
    if (!preisAnfragen.has(server)) {
      const anfrage = fetch(server + '/api/geraete').then((antwort) => {
        if (!antwort.ok) throw new Error('Preise nicht erreichbar');
        return antwort.json();
      });
      // Ein Fehlschlag soll beim naechsten Versuch neu fragen.
      anfrage.catch(() => preisAnfragen.delete(server));
      preisAnfragen.set(server, anfrage);
    }
    return preisAnfragen.get(server);
  }

  // Namen kommen ueber den Preis-Watcher von einer fremden Seite - deshalb
  // textContent statt innerHTML.
  function kachel(href, titel, zusatz, preis) {
    const link = document.createElement('a');
    link.className = 'ak-kachel';
    link.href = href;
    for (const [klasse, text] of [['ak-kachel__titel', titel], ['ak-kachel__zusatz', zusatz], ['ak-kachel__preis', preis]]) {
      if (!text) continue;
      const teil = document.createElement('span');
      teil.className = klasse;
      teil.textContent = text;
      link.appendChild(teil);
    }
    return link;
  }

  function zeigeHinweis(behaelter, text, art) {
    behaelter.textContent = '';
    const kasten = document.createElement('div');
    kasten.className = 'ak-hinweis ak-hinweis--' + art;
    kasten.textContent = text;
    behaelter.appendChild(kasten);
  }

  function auftragsListe(zeilen) {
    const liste = document.createElement('dl');
    liste.className = 'ak-gitter';
    for (const [titel, wert] of zeilen) {
      const block = document.createElement('div');
      const dt = document.createElement('dt');
      dt.textContent = titel;
      const dd = document.createElement('dd');
      dd.textContent = wert;
      block.append(dt, dd);
      liste.appendChild(block);
    }
    return liste;
  }

  // --- Startseite -----------------------------------------------------------

  function startseite(wurzel, teil, server) {
    const verkaufen = wurzel.dataset.seiteVerkaufen;

    ladeGeraete(server)
      .then((daten) => {
        teil('stand').textContent = 'Preise vom ' + datumLang(daten.stand);
        const geraete = daten.geraete;
        if (geraete.length === 0) return;

        for (const marke of eindeutig(geraete.map((g) => g.marke))) {
          const eigene = geraete.filter((g) => g.marke === marke);
          const anzahl = eindeutig(eigene.map((g) => g.modell)).length;
          const hoechster = Math.max(...eigene.map((g) => g.bestpreis_cent));
          teil('marken-kacheln').appendChild(
            kachel(
              verkaufen + '?' + new URLSearchParams({ marke }),
              marke,
              anzahl === 1 ? '1 Modell' : `${anzahl} Modelle`,
              'bis ' + euro(hoechster),
            ),
          );
        }
        teil('marken-bereich').classList.remove('ak-versteckt');

        const top = [...geraete].sort((a, b) => b.bestpreis_cent - a.bestpreis_cent).slice(0, 4);
        for (const g of top) {
          teil('hoechste-preise').appendChild(
            kachel(verkaufen + '?' + new URLSearchParams({ geraet: g.id }), `${g.marke} ${g.modell}`, g.speicher, euro(g.bestpreis_cent)),
          );
        }
        teil('hoechste-bereich').classList.remove('ak-versteckt');
      })
      .catch(() => {
        teil('stand').textContent = 'Die Preise konnten gerade nicht geladen werden.';
      });
  }

  // --- Verkaufs-Assistent ---------------------------------------------------
  // Der Schritt steht in der Adresse (?marke=…&modell=… oder ?geraet=…), damit
  // Zurueck im Browser funktioniert und die Startseite direkt hineinverlinken kann.

  function verkaufen(wurzel, teil, server) {
    const pfad = location.pathname;
    let geraete = [];
    // Wir kaufen nur originalversiegelte Geraete an - der Schluessel kommt
    // trotzdem vom Server, falls spaeter weitere Zustaende dazukommen.
    let zustandSchluessel = 'versiegelt';
    let gewaehltesGeraet = null;

    const adresse = (werte) => {
      const abfrage = new URLSearchParams(werte).toString();
      return pfad + (abfrage ? '?' + abfrage : '');
    };

    function schrittKachel(href, titel, zusatz, preis) {
      const link = kachel(href, titel, zusatz, preis);
      link.dataset.schritt = '';
      return link;
    }

    function auswahlAusAdresse() {
      const werte = new URLSearchParams(location.search);
      const geraet = geraete.find((g) => String(g.id) === werte.get('geraet'));
      if (geraet) return { schritt: 'daten', geraet };

      const marke = werte.get('marke');
      const modell = werte.get('modell');
      if (!geraete.some((g) => g.marke === marke)) return { schritt: 'marke' };
      if (!geraete.some((g) => g.marke === marke && g.modell === modell)) return { schritt: 'modell', marke };
      return { schritt: 'speicher', marke, modell };
    }

    function baueMarken() {
      const ziel = teil('marken-liste');
      ziel.textContent = '';
      for (const marke of eindeutig(geraete.map((g) => g.marke))) {
        const eigene = geraete.filter((g) => g.marke === marke);
        const anzahl = eindeutig(eigene.map((g) => g.modell)).length;
        ziel.appendChild(
          schrittKachel(adresse({ marke }), marke, anzahl === 1 ? '1 Modell' : `${anzahl} Modelle`, hoechstpreis(eigene)),
        );
      }
    }

    function baueModelle(marke) {
      teil('titel-modell').textContent = `Welches ${marke}-Modell hast du?`;
      teil('zurueck-modell').href = adresse({});
      const ziel = teil('modelle-liste');
      ziel.textContent = '';
      const eigene = geraete.filter((g) => g.marke === marke);
      for (const modell of eindeutig(eigene.map((g) => g.modell))) {
        const varianten = eigene.filter((g) => g.modell === modell);
        ziel.appendChild(
          schrittKachel(
            adresse({ marke, modell }),
            modell,
            varianten.length === 1 ? varianten[0].speicher : `${varianten.length} Speichergrößen`,
            hoechstpreis(varianten),
          ),
        );
      }
    }

    function baueSpeicher(marke, modell) {
      teil('titel-speicher').textContent = `Wie viel Speicher hat dein ${modell}?`;
      teil('zurueck-speicher').href = adresse({ marke });
      const ziel = teil('speicher-liste');
      ziel.textContent = '';
      const varianten = geraete
        .filter((g) => g.marke === marke && g.modell === modell)
        .sort((a, b) => speicherInGb(a.speicher) - speicherInGb(b.speicher));
      for (const g of varianten) {
        ziel.appendChild(schrittKachel(adresse({ geraet: g.id }), g.speicher, null, euro(g.bestpreis_cent)));
      }
    }

    function baueDaten(geraet) {
      gewaehltesGeraet = geraet;
      fehlerLeeren();
      teil('zurueck-daten').href = adresse({ marke: geraet.marke, modell: geraet.modell });
      const angebot = geraet.angebote[zustandSchluessel];
      teil('preis-anzeige').textContent = angebot ? angebot.anzeige : euro(geraet.bestpreis_cent);
      teil('preis-details').textContent = geraet.bezeichnung + ' · originalversiegelt';
    }

    function zeige() {
      // Der Theme-Editor ersetzt Abschnitte - ein alter hoert dann einfach auf.
      if (!wurzel.isConnected || geraete.length === 0) return;
      const auswahl = auswahlAusAdresse();
      const aktiv = SCHRITTE.indexOf(auswahl.schritt);

      teil('fertig').classList.add('ak-versteckt');
      teil('fortschritt').classList.remove('ak-versteckt');
      teil('fortschritt').querySelectorAll('li').forEach((punkt, i) => {
        punkt.classList.toggle('ak-fertig', i < aktiv);
        punkt.classList.toggle('ak-aktiv', i === aktiv);
      });
      for (const schritt of SCHRITTE) {
        teil('schritt-' + schritt).classList.toggle('ak-versteckt', schritt !== auswahl.schritt);
      }

      if (auswahl.schritt === 'marke') baueMarken();
      else if (auswahl.schritt === 'modell') baueModelle(auswahl.marke);
      else if (auswahl.schritt === 'speicher') baueSpeicher(auswahl.marke, auswahl.modell);
      else baueDaten(auswahl.geraet);
    }

    function gehe(ziel) {
      history.pushState(null, '', ziel);
      zeige();
      window.scrollTo(0, 0);
    }

    function fehlerLeeren() {
      wurzel.querySelectorAll('[data-feld]').forEach((feld) => {
        feld.classList.remove('ak-feld--fehler');
        const meldung = feld.querySelector('.ak-feld__fehler');
        if (meldung) meldung.remove();
      });
      // Solange der Verkauf nicht freigeschaltet ist, gibt es kein Formular.
      if (teil('formular-fehler')) teil('formular-fehler').textContent = '';
    }

    function zeigeFeldfehler(felder) {
      for (const [name, text] of Object.entries(felder)) {
        const feld = wurzel.querySelector(`[data-feld="${CSS.escape(name)}"]`);
        if (!feld) continue;
        feld.classList.add('ak-feld--fehler');
        const meldung = document.createElement('div');
        meldung.className = 'ak-feld__fehler';
        meldung.textContent = text;
        feld.appendChild(meldung);
      }
    }

    async function absenden(ereignis) {
      ereignis.preventDefault();
      fehlerLeeren();

      const knopf = teil('absenden');
      knopf.disabled = true;
      knopf.textContent = 'Wird gesendet …';

      const nutzlast = Object.fromEntries(new FormData(teil('formular')).entries());
      nutzlast.geraet_id = gewaehltesGeraet.id;
      nutzlast.zustand = zustandSchluessel;

      try {
        const antwort = await fetch(server + '/api/auftraege', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(nutzlast),
        });
        const daten = await antwort.json();

        if (!antwort.ok) {
          if (daten.felder) zeigeFeldfehler(daten.felder);
          zeigeHinweis(teil('formular-fehler'), daten.fehler || 'Das hat nicht geklappt.', 'fehler');
          return;
        }

        teil('fortschritt').classList.add('ak-versteckt');
        teil('schritt-daten').classList.add('ak-versteckt');
        teil('fertig').classList.remove('ak-versteckt');
        teil('fertig-nummer').textContent = daten.nummer;
        teil('fertig-geraet').textContent = daten.geraet;
        teil('fertig-preis').textContent = daten.preis_anzeige;
        teil('fertig-gueltig').textContent = datumLang(daten.gueltig_bis);
        teil('fertig-status').href = wurzel.dataset.seiteStatus + '?' + new URLSearchParams({ nummer: daten.nummer });
        // Neu laden soll nicht denselben Verkauf nochmal anbieten.
        history.replaceState(null, '', pfad);
        window.scrollTo(0, 0);
      } catch {
        zeigeHinweis(teil('formular-fehler'), 'Keine Verbindung. Bitte nochmal versuchen.', 'fehler');
      } finally {
        knopf.disabled = false;
        knopf.textContent = 'Jetzt verbindlich verkaufen';
      }
    }

    wurzel.addEventListener('click', (ereignis) => {
      const link = ereignis.target.closest('a[data-schritt]');
      if (!link || ereignis.button !== 0 || ereignis.ctrlKey || ereignis.metaKey || ereignis.shiftKey) return;
      ereignis.preventDefault();
      gehe(link.getAttribute('href'));
    });

    window.addEventListener('popstate', zeige);

    if (teil('formular')) {
      teil('formular').addEventListener('submit', absenden);
      teil('nochmal').addEventListener('click', () => {
        teil('formular').reset();
        gehe(pfad);
      });
    }

    ladeGeraete(server)
      .then((daten) => {
        geraete = daten.geraete;
        if (daten.zustaende.length > 0) zustandSchluessel = daten.zustaende[0].schluessel;

        if (geraete.length === 0) {
          teil('lade-meldung').textContent =
            'Für heute sind noch keine Preise eingetragen. Bitte schau später nochmal vorbei.';
          return;
        }
        teil('lade-meldung').classList.add('ak-versteckt');
        zeige();
      })
      .catch(() => {
        teil('lade-meldung').textContent = 'Die Preise konnten gerade nicht geladen werden. Bitte lade die Seite neu.';
      });
  }

  // --- Auftrag verfolgen ----------------------------------------------------

  function status(wurzel, teil, server) {
    async function verfolgen() {
      const nummer = teil('nummer').value.trim().toUpperCase();
      const ziel = teil('ergebnis');

      if (!nummer) {
        zeigeHinweis(ziel, 'Bitte gib deine Auftragsnummer ein.', 'warnung');
        return;
      }
      if (!server) {
        zeigeHinweis(ziel, 'Der Auftragsstatus ist gerade nicht erreichbar.', 'fehler');
        return;
      }

      try {
        const antwort = await fetch(server + '/api/auftraege/' + encodeURIComponent(nummer));
        const daten = await antwort.json();

        if (!antwort.ok) {
          zeigeHinweis(ziel, daten.fehler || 'Das hat nicht geklappt.', 'warnung');
          return;
        }

        const zeilen = [
          ['Gerät', daten.geraet_text],
          ['Status', daten.status_titel],
          ['Zugesagt', daten.preis_anzeige],
        ];
        if (daten.final_anzeige) zeilen.push(['Ausgezahlt', daten.final_anzeige]);
        ziel.textContent = '';
        ziel.appendChild(auftragsListe(zeilen));
      } catch {
        zeigeHinweis(ziel, 'Keine Verbindung.', 'fehler');
      }
    }

    teil('formular').addEventListener('submit', (ereignis) => {
      ereignis.preventDefault();
      verfolgen();
    });

    const vorbelegt = new URLSearchParams(location.search).get('nummer');
    if (vorbelegt) {
      teil('nummer').value = vorbelegt;
      verfolgen();
    }
  }

  // --- Verdrahtung ----------------------------------------------------------

  const ANSICHTEN = { start: startseite, verkaufen, status };

  function einrichten() {
    document.querySelectorAll('[data-ankauf]:not([data-ankauf-bereit])').forEach((wurzel) => {
      wurzel.dataset.ankaufBereit = '';
      const ansicht = ANSICHTEN[wurzel.dataset.ansicht];
      if (!ansicht) return;
      const teil = (name) => wurzel.querySelector(`[data-teil="${name}"]`);
      ansicht(wurzel, teil, serverAdresse(wurzel));
    });
  }

  window.ankaufEinrichten = einrichten;
  einrichten();
  // Der Theme-Editor laedt geaenderte Abschnitte ohne die ganze Seite neu.
  document.addEventListener('shopify:section:load', einrichten);
})();
